/* eslint-disable import/prefer-default-export */
import textSystem, { nameSystem } from '../constants/TextSystem';

export const getTextBySystem = (key, system) => {
  if (system) {
    const text = textSystem[system] && textSystem[system][key];
    if (text) {
      if (text) {
        return text;
      }
    } else {
      const textFukuoka =
        textSystem[nameSystem.fukuoka] && textSystem[nameSystem.fukuoka][key];
      if (textFukuoka) {
        return textFukuoka;
      }
    }
  }

  return key;
};
